var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Bar',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":"global-statistique-chart","styles":_vm.styles}})
}
var staticRenderFns = []

export { render, staticRenderFns }